/**
 * REVIEWER 저장 차단 — 이 프로젝트의 관례를 그대로 따른다.
 *
 * 백엔드 `ReviewerWriteGuard`가 이미 막지만, 프론트에서 먼저 팝업을 띄우는 이유는
 * REVIEWER가 데모 중에 403 에러 화면을 보지 않게 하기 위해서다.
 */
export const REVIEWER_BLOCKED_MESSAGE =
  'demo를 위한 기능은 여기까지 제공됩니다. 실제 데이터는 저장되지 않습니다.';

/** 차단했으면 `true` — 호출부는 `if (blockReviewer(...)) return;` 형태로 쓴다 */
export const blockReviewer = (isReviewer: boolean): boolean => {
  if (!isReviewer) return false;

  window.alert(REVIEWER_BLOCKED_MESSAGE);
  return true;
};

/**
 * 구매수량 입력은 숫자만 받는다 — `12a3` 같은 값이 그대로 저장되면 API가 400을 던진다.
 * 그리고 **소수 1자리까지** 받는다.
 *
 * 한 계약을 두 회사가 반씩 갖는 경우가 있어 `0.5`가 들어온다. 반대로 DB 컬럼이
 * `Decimal(10,1)`이라 2자리 이상은 백엔드가 400으로 막으므로, 입력 단계에서
 * 같은 규칙으로 정리한다 — 저장을 눌러야 알게 되면 입력한 값을 잃는다.
 *
 * 입력 중인 `0.`은 지우지 않는다. 지우면 소수점을 이어서 찍을 수 없다.
 */
export const decimalOnly = (value: string): string => {
  const cleaned = value.replace(/[^\d.]/g, '');
  const [head, ...rest] = cleaned.split('.');

  if (rest.length === 0) return head;
  // 두 번째 이후의 점은 버리고, 소수부는 1자리만 남긴다
  return `${head}.${rest.join('').slice(0, 1)}`;
};

/** 빈 칸은 0이다. `undefined`를 보내면 백엔드 숫자 검증에서 400이 난다 */
export const toAmount = (value: string): number => {
  if (value === '') return 0;
  const parsed = Number(value);
  // `0.`처럼 입력 중인 값도 0.5 단위 오차 없이 숫자로 만든다
  return Number.isFinite(parsed) ? Math.round(parsed * 10) / 10 : 0;
};
